import * as React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

export const ConfirmDialog = ({
  open,
  title = 'Confirm',
  description = 'Are you sure?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  onConfirm,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ fontSize: '28px' }}>{title}</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ fontSize: '24px' }}>
          {description}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ fontSize: '24px', padding: '4px 32px' }}
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </Button>

        <Button
          onClick={onConfirm}
          color='error'
          variant='contained'
          sx={{ fontSize: '24px', padding: '4px 32px' }}
          disabled={loading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
